export default "__VITE_ASSET__BJISh5dz__"